import type { CatalogueCounty } from './types.js';

// U.S. Census Bureau TIGERweb ACS25 county catalogue.
export const WEST_VIRGINIA_COUNTIES: readonly CatalogueCounty[] = [
  { name: "Barbour", state: "WV", fips: "54001" },
  { name: "Berkeley", state: "WV", fips: "54003" },
  { name: "Boone", state: "WV", fips: "54005" },
  { name: "Braxton", state: "WV", fips: "54007" },
  { name: "Brooke", state: "WV", fips: "54009" },
  { name: "Cabell", state: "WV", fips: "54011" },
  { name: "Calhoun", state: "WV", fips: "54013" },
  { name: "Clay", state: "WV", fips: "54015" },
  { name: "Doddridge", state: "WV", fips: "54017" },
  { name: "Fayette", state: "WV", fips: "54019" },
  { name: "Gilmer", state: "WV", fips: "54021" },
  { name: "Grant", state: "WV", fips: "54023" },
  { name: "Greenbrier", state: "WV", fips: "54025" },
  { name: "Hampshire", state: "WV", fips: "54027" },
  { name: "Hancock", state: "WV", fips: "54029" },
  { name: "Hardy", state: "WV", fips: "54031" },
  { name: "Harrison", state: "WV", fips: "54033" },
  { name: "Jackson", state: "WV", fips: "54035" },
  { name: "Jefferson", state: "WV", fips: "54037" },
  { name: "Kanawha", state: "WV", fips: "54039" },
  { name: "Lewis", state: "WV", fips: "54041" },
  { name: "Lincoln", state: "WV", fips: "54043" },
  { name: "Logan", state: "WV", fips: "54045" },
  { name: "McDowell", state: "WV", fips: "54047" },
  { name: "Marion", state: "WV", fips: "54049" },
  { name: "Marshall", state: "WV", fips: "54051" },
  { name: "Mason", state: "WV", fips: "54053" },
  { name: "Mercer", state: "WV", fips: "54055" },
  { name: "Mineral", state: "WV", fips: "54057" },
  { name: "Mingo", state: "WV", fips: "54059" },
  { name: "Monongalia", state: "WV", fips: "54061" },
  { name: "Monroe", state: "WV", fips: "54063" },
  { name: "Morgan", state: "WV", fips: "54065" },
  { name: "Nicholas", state: "WV", fips: "54067" },
  { name: "Ohio", state: "WV", fips: "54069" },
  { name: "Pendleton", state: "WV", fips: "54071" },
  { name: "Pleasants", state: "WV", fips: "54073" },
  { name: "Pocahontas", state: "WV", fips: "54075" },
  { name: "Preston", state: "WV", fips: "54077" },
  { name: "Putnam", state: "WV", fips: "54079" },
  { name: "Raleigh", state: "WV", fips: "54081" },
  { name: "Randolph", state: "WV", fips: "54083" },
  { name: "Ritchie", state: "WV", fips: "54085" },
  { name: "Roane", state: "WV", fips: "54087" },
  { name: "Summers", state: "WV", fips: "54089" },
  { name: "Taylor", state: "WV", fips: "54091" },
  { name: "Tucker", state: "WV", fips: "54093" },
  { name: "Tyler", state: "WV", fips: "54095" },
  { name: "Upshur", state: "WV", fips: "54097" },
  { name: "Wayne", state: "WV", fips: "54099" },
  { name: "Webster", state: "WV", fips: "54101" },
  { name: "Wetzel", state: "WV", fips: "54103" },
  { name: "Wirt", state: "WV", fips: "54105" },
  { name: "Wood", state: "WV", fips: "54107" },
  { name: "Wyoming", state: "WV", fips: "54109" },
];
